import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/a2v')({
  component: A2vLayout,
});

function A2vLayout() {
  return <Outlet />;
}
